import NodeRSA from 'node-rsa';
import forge from 'node-forge';
import {store} from './configureStore';


const encryptStringWithPublicKey2 = (plainText) => {
    const publicKey = store.getState().appConfig.publicKey;
    let publicKeyFromPem = forge.pki.publicKeyFromPem(publicKey);
    let encrypted = publicKeyFromPem.encrypt(plainText, "RSA-OAEP");
    let encoded_encryted = forge.util.encode64(encrypted)
    return encoded_encryted;
}

const encryptStringWithPublicKey = (textToEncrypt) => {
    try {
        const pKeyValue = '-----BEGIN PUBLIC KEY-----MIIBIjANBgkqhkiG9w0BAQEFAAOCAQ8AMIIBCgKCAQEAxzI6j7NCJ//r7mEmue9+vlgsjU/zp/XnKO0BykyJQiWxZfMZ9QruDNfO6kmacwtMlESg2kBaql2Gvk8HPm7AJVkcTlPvvkuvbHF6xMK+Byaqp354CbFdT03UVv8AvfMkGjiziWBxIkpNy+thvp5Z/k1nDtduIHP6XsuCrhJVKjgSilkwZJsFq9IrwGfC+Re7CV7wh1QVk3pmD3zGR5DEbMwdnsRHN9VbqFowzOepUEAWT75EKqFlBuegaPx5L61NwzYTm8eRumy9iBgbts4mKdkTCwmk8iiKgspwnIHTBI1moqXN3p7ywfH5Vu5db/4x/5D+PTDZpill2VqZ/MZUqwIDAQAB-----END PUBLIC KEY-----';
        const pKey = new NodeRSA(pKeyValue);
        return pKey.encrypt(textToEncrypt, 'base64');
    } catch (error) {
        throw new Error(error.message);
    }
}

const encryptStringWithElogPublicKey = (textToEncrypt) => {
    // console.log('textToEncrypt',textToEncrypt);
    try {
        // const pKeyValue = "-----BEGIN PUBLIC KEY-----MIIBIjANBgkqhkiG9w0BAQEFAAOCAQ8AMIIBCgKCAQEA1sBi07HE28X+nYBcizwnWlW0xC7xGnkwQBKdtrpSeZwYMhFSEKymQck2QyNdsS3k7myPIs636y2FjRV4JKPy8+qH2EOU6EUHUI6oEQQO5VG9YUKstE2IOL9aGhgSokxd41RcjuevFqSHVQWV4wNTk2o9rLHai9BuqHA68s8v7DcuEv1+IrO0lLqfNTUbQM0iIy5AfSn8D5utSB8YUAg4aSFSlEFlkw+brJ5sPpiRpgDzmJYUXQ9wRbA1YoHvSLtjzthsQp0VS+c6g+Z6Mq7DJ0EI3+koXLrFTn9AeSjOMQdIDMRKS4RzioM7tS3mUqMvevmnqAjTjN9ZKxp7Cb3wFQIDAQAB-----END PUBLIC KEY-----";
        const pKeyValue = '-----BEGIN PUBLIC KEY-----MIIBIjANBgkqhkiG9w0BAQEFAAOCAQ8AMIIBCgKCAQEAxzI6j7NCJ//r7mEmue9+vlgsjU/zp/XnKO0BykyJQiWxZfMZ9QruDNfO6kmacwtMlESg2kBaql2Gvk8HPm7AJVkcTlPvvkuvbHF6xMK+Byaqp354CbFdT03UVv8AvfMkGjiziWBxIkpNy+thvp5Z/k1nDtduIHP6XsuCrhJVKjgSilkwZJsFq9IrwGfC+Re7CV7wh1QVk3pmD3zGR5DEbMwdnsRHN9VbqFowzOepUEAWT75EKqFlBuegaPx5L61NwzYTm8eRumy9iBgbts4mKdkTCwmk8iiKgspwnIHTBI1moqXN3p7ywfH5Vu5db/4x/5D+PTDZpill2VqZ/MZUqwIDAQAB-----END PUBLIC KEY-----';
        const pKey = forge.pki.publicKeyFromPem(pKeyValue);
        const buffer = forge.util.createBuffer(textToEncrypt.toUpperCase(), 'utf8');
        const binaryString = buffer.getBytes();
        let encryptText = pKey.encrypt(binaryString, 'RSA-OAEP', {
            md: forge.md.sha256.create(),
            mgf1: {
                md: forge.md.sha256.create()
            }
        });
        // return forge.util.encode64(encryptText);
        encryptText = forge.util.encode64(encryptText);
        encryptText = encodeURIComponent(encryptText);
        return encryptText;
    } catch (error) {
        throw new Error(error.message);
    }
}

export {
    encryptStringWithPublicKey,
    encryptStringWithPublicKey2,
    encryptStringWithElogPublicKey,
};
